// Ponto único de entrada para o WhatsApp. Vive fora de LandingPageV2 porque o
// ícone flutuante (LandingPage/IconeZapZap) também precisa dele, e antes disso
// mantinha a URL duplicada e disparava window.open por conta própria - o que
// deixava o CTA mais visível da página fora da medição.

export const WHATSAPP_URL =
  'https://wa.me/5584991270936?text=Ol%C3%A1%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20a%20respeito%20do%20atendimento%20online%20de%20fonoaudiologia.%0A%0APreencha%20os%20campos%20abaixo%3A%0ANome%20do%20respons%C3%A1vel%20%28caso%20paciente%20seja%20crian%C3%A7a%29%3A%0ANome%20do%20Paciente%3A%0AIdade%3A%0AQueixa%3A'

// Ação de conversão "Clique WhatsApp - Site" (categoria Contato) do Google Ads.
// É o sinal de lead de verdade: a conversão antiga disparava em todo pageview,
// então 100% dos cliques contavam como sucesso e o "Maximizar conversões" das
// campanhas acabava perseguindo clique barato em vez de gente interessada.
const WHATSAPP_LEAD_CONVERSION = 'AW-16655786513/S4CDCO_Dud0cEJHEjIY-'

export const openWhatsApp = () => {
  // gtag() é síncrono: o stub no index.html só empilha no dataLayer, e a fila é
  // reproduzida quando a biblioteca carrega. Por isso dá para chamar antes do
  // window.open sem atrasar nada e sem o navegador perder o vínculo com o
  // gesto do usuário (o que faria o bloqueador de pop-up barrar a aba).
  // O `?.` cobre o caso de um bloqueador de anúncios ter removido o gtag - aí
  // a conversão se perde, mas o WhatsApp abre do mesmo jeito.
  window.gtag?.('event', 'conversion', { send_to: WHATSAPP_LEAD_CONVERSION })

  // Sem event_callback de propósito: o exemplo que o Google gera usa
  // window.location para navegar depois do beacon, mas aqui a aba atual
  // continua aberta, então a requisição termina sozinha.
  window.open(WHATSAPP_URL, '_blank')
}
